export type ProjectNameRequestContext = Readonly<{
  generation: number;
  routeName: string;
  projectId: number;
}>;

export function isProjectNameRequestCurrent(
  request: ProjectNameRequestContext,
  current: ProjectNameRequestContext,
): boolean {
  return request.generation === current.generation
    && request.routeName === current.routeName
    && request.projectId === current.projectId;
}

export function sessionTitleCacheKey(sessionId: string, scenario: string): string {
  return `${scenario}::${sessionId}`;
}
